<template>
	<div v-if="props.settings && props.settings.heading" style="font-weight:500;font-size:20px;margin-bottom:10px;margin-top:10px;margin-left:15px;">{{ props.settings.heading }}</div>
	<DxList :data-source="dataItemsSource" :searchEnabled="effectiveSearchSettings" :searchExpr="[ 'title', 'body', 'badge' ]" ref="listComponent" @item-click="handleActionImmediate">
		<template #item="{ data: item }">
			<div>{{ bindings['title'] ? item[bindings['title']] : '' }}</div>
			<div style="font-style:italic;color:#999;font-size:14px;">{{ bindings['subtitle'] ? item[bindings['subtitle']] : '' }}</div>
		</template>
	</DxList>
</template>

<script setup>
/* eslint-disable */
import { DxList } from 'devextreme-vue/list';
import { defineProps, watch, ref, inject, computed } from 'vue';
import DataSource from "devextreme/data/data_source"
import { SchemaCache } from '@/schemas.js';

const $http = inject('$http');
const props = defineProps([
	'preview',
	'settings',
	'context'
]);

// Effective bindings: title, subtitle, badge. Stored binding path uses full keyspec, e.g. customer.name instead of just name - so we extract the last part.
const bindings = computed(() => {
	return {
		title: props.settings.bindTitle ? props.settings.bindTitle.split('.').pop() : '',
		subtitle: props.settings.bindSubtitle ? props.settings.bindSubtitle.split('.').pop() : '',
		badge: props.settings.bindBadge ? props.settings.bindBadge.split('.').pop() : ''
	}
});

const listComponent = ref(null);
const dataColumns = ref([]);
const dataItemsSource = new DataSource({
	loadMode: 'raw',
	load: async (loadOptions) => {
		if (!props.settings || !props.settings.source)
			return [];
		let fetchRequest = await $http.get('/mote', { params: { type: props.settings.source } });
		let result = fetchRequest.data.motes.map(({ payload, ...datum }) => ({
			...(payload || {}),
			...datum
		}));
		console.log("List", result);
		return result;
	},
	map: function(item) {
		item.badge = bindings.value.badge && item[bindings.value.badge] ? item[bindings.value.badge] : '';
		return item;
	}
});

const effectiveSearchSettings = ref(false);

watch(props, async () => {
	dataColumns.value.length = 0;
	await SchemaCache.waitForData();
	var columns = props.settings.source ? (SchemaCache.getSchemaByType(props.settings.source)?.fields ?? []) : [];
	dataColumns.value = columns.map(c => c.field);
	
	// TODO: Handle effectiveSearchSettings?
	
	dataItemsSource.filter(null);
	if (props.settings && props.settings.filter) {
		dataItemsSource.filter(props.settings.filter);
	}

	dataItemsSource.load();
	if (listComponent.value) {
		// Unneeded?
		// listComponent.value.instance.reload(); 
	}
}, {
	immediate: true
});

// Action binds for ux-list: click, hold.
const handleActionImmediate = (e) => {
	const eventType = e.event?.type ?? '';
	switch (eventType.toLowerCase()) {
		case 'dxclick':
			break;
		case 'dxhold':
			break;
		default:
			console.warn("Unknown immediate action event type, ignoring invocation.", e);
			break;
	}
}


</script>
